import { Component, Input, OnInit } from '@angular/core';

import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { MyAccountAnalyticsService } from '@shared/data-access/services';
import { Order } from '@shared/data-access/interfaces';

@Component({
	selector: 'my-account-components-checkin-button',
	templateUrl: './checkin-button.component.html',
	styleUrls: ['./checkin-button.component.scss']
})
export class CheckinButtonComponent implements OnInit {

	@Input()
		orderDetail: Order;

	@Input()
		resetCheckIn: BehaviorSubject<boolean>;

	@Input()
		zipCode: string;

	errorMessage: string;

	constructor(private analyticsService: MyAccountAnalyticsService) {
	}

	ngOnInit(): void {

		if (this.resetCheckIn) {
			this.resetCheckIn.subscribe((reset) => {
				if (reset) {
					this.errorMessage = null;
				}
			});
		}
	}

	submitCheckIn() {
		this.analyticsService.setEventType('CurbsideCheckIn');
		this.analyticsService.triggerAnalyticsEvent('CurbsideCheckIn');

		const orderNumber = this.orderDetail.orderNumber.toString();
		const zipCode = this.orderDetail.zipCode;
		window.location.href = `/s/orderpickup/?orderNumber=${orderNumber}&zipCode=${zipCode}`;
	}

	readyForPickUp(): boolean {
		if (!this.orderDetail.items) {
			return false;
		}

		const bopisItems = this.orderDetail.items.filter((x) => { return x.bopisItem === true; }).map((item) => { return item.status === 'Ready For Pickup'; } );

		if (!bopisItems || bopisItems.length === 0) {
			return false;
		}

		return bopisItems.reduce((prev, cur) => { return prev || cur; });
	}
}
